import { ArrowLeft } from "lucide-react";

// Ecrã de um passo (documento ou pergunta): voltar, título, porquê e a ação.
export function DocScreen({ title, heading, why, onBack, children, testid = "portal-doc-screen" }) {
  return (
    <div className="space-y-5" data-testid={testid}>
      <div className="flex items-center gap-2">
        <button type="button" onClick={onBack} aria-label="Voltar" className="w-10 h-10 -ml-2 grid place-items-center rounded-full hover:bg-slate-100 text-slate-700" data-testid={`${testid}-back`}><ArrowLeft size={22} /></button>
        <div className="flex-1 min-w-0 text-center font-semibold text-slate-800 truncate pr-8">{title}</div>
      </div>
      {heading && <div>
        <h1 className="font-heading text-2xl brand-text leading-tight" data-testid={`${testid}-heading`}>{heading}</h1>
        {why && <p className="text-[15px] text-slate-500 mt-1.5">{why}</p>}
      </div>}
      {children}
    </div>
  );
}
